import { useCallback } from "react"
import { Button, TextField, type TextFieldProps, toast } from "@octopus-energy/coral/atoms"
import { IconCopy } from "@octopus-energy/icons"
import { copyToClipboard } from "@octopus-energy/utils"
import { useTranslations } from "next-intl"

type CopyFieldProps = {
    attributes: TextFieldProps["attributes"]
    value: string
    label: string
    successMessage: string
}

export function CopyField({ attributes, value, label, successMessage }: CopyFieldProps) {
    const t = useTranslations("CopyField")

    const copyValue = useCallback(() => {
        copyToClipboard(value)
        toast(successMessage, { type: "success" })
    }, [successMessage, value])

    return (
        <TextField
            attributes={attributes}
            defaultValue={value}
            onFocus={copyValue}
            inputProps={{ readOnly: true }}
            endIcon={
                <Button
                    variant="text"
                    aria-label={t("ariaLabel")}
                    onClick={copyValue}
                >
                    <IconCopy size={24} />
                </Button>
            }
            label={label}
            type="link"
        />
    )
}

CopyField.messages = ["CopyField"] as const
